import { MilkNurseryDomainService } from './domain';
import { MilkFactory } from './entity/milkFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { MilkJson } from '@/types/domain/milk/entities/milkEntity';

/**
 * ミルクアプリケーションサービス(施設)
 */
export class MilkNurseryApplicationService {
  private service!: MilkNurseryDomainService;

  private milkFactory = new MilkFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new MilkNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurseryMilk
   * @param input 入力
   */
  async sendNurseryMilk(
    input: MilkJson,
  ) {
    const entity = this.milkFactory.createFromJson(input);
    await this.service.sendNurseryMilk(entity);
  }

  /**
   * removeNurseryMilk
   * @param input 入力
   */
  async removeNurseryMilk(
    input: MilkJson,
  ) {
    const entity = this.milkFactory.createFromJson(input);
    await this.service.removeNurseryMilk(entity);
  }
}
